import { NgModule, isDevMode, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, registerLocaleData } from '@angular/common';
import { MaterialModule } from './shared/MaterialAngular/material.module';
import { LoginModule } from './features/Login/login.module';
import { HomeModule } from './features/home/home.module';
import { authReducer } from './core/auth/store/reducers/auth.reducer';
import { AuthEffects } from './core/auth/effects/auth.effects';
import { partnerReducer } from './core/partners/store/reducers/partners.reducer';
import { PartnerEffects } from './core/partners/effects/partners.effects';
import { RidersEffects } from './core/riders/effects/riders.effects';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { DeliveryRequestEffects } from './core/delivery-requests/effects/delivery-requests.effects';
import { requestReducer } from './core/delivery-requests/store/reducers/delivery-requests.reducer';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptor } from './core/http-interceptors/http.interceptor';
import { categoryReducer } from './core/partners/store/categories-partners/categories-reducer';
import { ridersReducer } from './core/riders/store/reducers/riders.reducer';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { OrdersEffects } from './core/orders/effects/orders.effects';
import { ordersReducer } from './core/orders/store/reducers/orders.reducer';
import { usersReducer } from './core/users/store/reducers/users.reducer';
import { UsersEffects } from './core/users/effects/users.effects';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { CitiesEffects } from './core/cities/effects/cities.effects';
import { citiesReducer } from './core/cities/store/reducers/cities.reducer';
import { ChatEffects } from './core/chat/effects/chat.effects';
import { chatReducer } from './core/chat/store/reducers/chat.reducer';
import { DiscardChangesDialogComponent } from './shared/discard-changes-dialog/discard-changes-dialog.component';
import { SseEffects } from './core/server-sent-events/effects/sse.effects';
import { sseReducer } from './core/server-sent-events/store/reducers/sse.reducer';
import { ScheduleEffects } from './core/schedule/effects/schedule-state.effects';
import localeEs from '@angular/common/locales/es';
import { exportedDataReducer } from './core/exported-data/store/reducers/exported-data.reducer';
import { ExportedDataEffects } from './core/exported-data/effects/exportes-data.effects';
import { manualServicesReducer} from './core/manual-services/store/reducers/manual-services.reducers';
import { ManualServicesEffects } from './core/manual-services/effects/manual-services.effects';
import { filterReducer } from './core/filters/store/reducers/filter.reducer';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getSpanishPaginatorIntl } from './shared/MatPaginatorES/mat-paginator-intl-es';
import { invoicesReducer } from './core/invoices/store/reducers/invoices.reducers';
import { InvoicesEffects } from './core/invoices/effects/invoices.effects';
// Registrar los datos de localización para "es-ES"
registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    DiscardChangesDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    StoreModule.forRoot({ 
      auth: authReducer, 
      partner: partnerReducer, 
      request: requestReducer, 
      category: categoryReducer, 
      riders: ridersReducer, 
      orders: ordersReducer,
      users: usersReducer,
      cities: citiesReducer,
      chat: chatReducer,
      sse: sseReducer,
      exportedData: exportedDataReducer,
      manualService: manualServicesReducer,
      filters: filterReducer,
      invoices: invoicesReducer
    }, {}),
    EffectsModule.forRoot([
      AuthEffects, 
      PartnerEffects, 
      DeliveryRequestEffects, 
      RidersEffects, 
      OrdersEffects, 
      UsersEffects,
      CitiesEffects,
      ChatEffects,
      SseEffects,
      ExportedDataEffects,
      ManualServicesEffects,
      InvoicesEffects
    ]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    CommonModule,
    MaterialModule,
    LoginModule,
    HomeModule,
    HttpClientModule,
    NgxChartsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-ES' }, // Configurar la localización por defecto\
    { provide: MatPaginatorIntl, useFactory: getSpanishPaginatorIntl }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }